import { Layout } from 'components/atoms'
import { InputBuild, SelectBuild } from 'components/molecules'

import { FormFinancingProps } from 'pages/Contracts/Components/Forms/FormFinancing/interfaces'
import React, { useMemo } from 'react'
import { useFormContext, useWatch } from 'react-hook-form'
import { FormVehicleValue } from './form'
import { ViewVehicleFormProps } from './interfaces'

const ViewVehicleForm: React.FC = () => {
    const { register, watch, control } = useFormContext<{
        vehicles: ViewVehicleFormProps
        vehiclesList?: ViewVehicleFormProps[]
        financing: FormFinancingProps
    }>()

    const form = useMemo(() => FormVehicleValue(), [])

    const principalVehicle = useWatch({
        control,
        name: 'vehicles'
    }) as ViewVehicleFormProps

    const vehiclesList = useWatch({
        control,
        name: 'vehiclesList',
        defaultValue: []
    }) as ViewVehicleFormProps[]

    const additionalVehicleIndexes = useMemo(() => {
        const seen = new Set<string>()
        const principalChassi = principalVehicle?.chassi
        if (principalChassi) seen.add(principalChassi)

        const uniqueIndexes: number[] = []
        vehiclesList.forEach((v, index) => {
            const chassi = v?.chassi
            if (!chassi) return
            if (seen.has(chassi)) return
            seen.add(chassi)
            uniqueIndexes.push(index)
        })
        return uniqueIndexes
    }, [principalVehicle?.chassi, vehiclesList])

    const renderVehicleFields = (basePath: string) => (
        <Layout type="row" gutter={{ y: 1.5 }} data-testid="form-fields">
            {form.map(({ layout, input, select }, key) => (
                <Layout {...layout} key={key}>
                    {select ? (
                        <SelectBuild
                            {...select}
                            {...register(`${basePath}.${select.id}` as any)}
                            isDisable={true}
                        />
                    ) : (
                        input && (
                            <InputBuild
                                {...input}
                                {...register(`${basePath}.${input.id}` as any)}
                                value={
                                    watch(
                                        `${basePath}.${input.id}` as any
                                    ) as any
                                }
                                isDisable={true}
                            />
                        )
                    )}
                </Layout>
            ))}
        </Layout>
    )

    return (
        <Layout
            full
            type="container"
            display="grid"
            gap={8}
            data-testid="form-container"
        >
            <Layout type="container" full display="grid" gap={8}>
                {renderVehicleFields('vehicles')}
            </Layout>

            {/* ADICIONAIS */}
            {additionalVehicleIndexes.length > 0 && (
                <Layout type="container" full display="grid" gap={6}>
                    {additionalVehicleIndexes.map((index, i) => (
                        <Layout
                            type="container"
                            key={`vehicle-${vehiclesList[index]?.chassi ?? index}`}
                            full
                            display="grid"
                            gap={4}
                        >
                            <Layout type="container" full>
                            <hr style={{ width: '100%', opacity: 1.2, margin: '16px 0' }} />
                            </Layout>

                            <Layout type="container" full display="grid" gap={8}>
                                {renderVehicleFields(`vehiclesList.${index}`)}
                            </Layout>
                        </Layout>
                    ))}
                </Layout>
            )}
        </Layout>
    )
}

export default ViewVehicleForm
